'use client';

/** Reservado — otimização AVIF desativada; imagens vêm direto do CDN. */
export default function AbfPushImageOptimizer() {
	return null;
}
